import { render, staticRenderFns } from "./avis-dossier.vue?vue&type=template&id=4be46355"
import script from "./avis-dossier.vue?vue&type=script&lang=js"
export * from "./avis-dossier.vue?vue&type=script&lang=js"
import style0 from "./avis-dossier.vue?vue&type=style&index=0&id=4be46355&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports